import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { en } from './locales/en'
import { vi } from './locales/vi'

const saved = (() => { try { return localStorage.getItem('meow.locale') } catch { return null } })()

void i18n.use(initReactI18next).init({
  resources: { vi: { translation: vi }, en: { translation: en } },
  lng: saved ?? (navigator.language.startsWith('en') ? 'en' : 'vi'),
  fallbackLng: 'vi',
  interpolation: { escapeValue: false }
})

i18n.on('languageChanged', lng => {
  document.documentElement.lang = lng
  try { localStorage.setItem('meow.locale', lng) } catch { /* private mode */ }
})

export default i18n
